import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import classnames from 'classnames';

import {Illustration} from 'shells/illustrations/illustration';
import {Link} from 'shells/link/link';
import {MarketingBody} from 'shells/typography/marketing-body';
import {MarketingHeader} from 'shells/typography/marketing-header';

import styles from './pause-page.module.css';

export function PausedPage() {
    const price = NutClientConfig.pauseInfo && NutClientConfig.pauseInfo.seatPriceDollars;
    const term = NutClientConfig.pauseInfo && NutClientConfig.pauseInfo.term;
    const userCount = NutClientConfig.numBillableUsers;

    const description =
        price && term
            ? `If you’re ready to start things up again, you can reactivate your Nutshell
                        account and your ${term} rate will return to $${price}/user for ${userCount}
                        users.`
            : 'If you’re ready to start things up again, you can reactivate your Nutshell account';

    return (
        <div className={classnames('pad-16', styles['pause-page'])}>
            <MarketingHeader>Your account is paused</MarketingHeader>
            <div className={classnames('flex', styles.body)}>
                <div className={styles.copy}>
                    <MarketingBody>{description}</MarketingBody>
                    <MarketingBody>
                        To change your team size before reactivating your account,{' '}
                        {/* @ts-expect-error */}
                        <Link as={RoutedLink} variant='primary' size='big' to='/setup/user'>
                            click here to manage your users
                        </Link>
                        .
                    </MarketingBody>
                    <div className={styles.buttons}>
                        <Link
                            variant='button-primary'
                            size='xlarge'
                            // Can't client route this, it needs to hit the server.
                            href='/setup/billing/restore-requested'
                        >
                            Reactivate my account
                        </Link>
                        {/* @ts-expect-error */}
                        <Link as={RoutedLink} to='/setup/billing/cancel'>
                            Cancel my account
                        </Link>
                    </div>
                </div>
                <Illustration src='paper-airplane' />
            </div>
        </div>
    );
}
